import { type ComponentProps } from 'react'
import { Col, Row } from 'react-bootstrap'
import { IntegrationServiceId } from '../../common/integrations'
import { useIntegrationRequirement } from '../../common/useIntegrationRequirement'
import { parseMetadata } from '../../common/util'
import { useAppSelector } from '../../store/hooks'
import { selectRoomSession } from '../../store/meetingSummary/roomSession'
import { ZoomOBFWarning } from './ZoomOBFWarning'

interface ZoomOBFWarningRowProps {
  rowProps?: ComponentProps<typeof Row>
  colProps?: ComponentProps<typeof Col>
}

export const ZoomOBFWarningRow: React.FC<ZoomOBFWarningRowProps> = ({ rowProps, colProps }) => {
  const roomSession = useAppSelector(selectRoomSession)
  const { source } = parseMetadata(roomSession?.metadata)
  const checkRequirement = useIntegrationRequirement()
  const { satisfied, accountAllowed } = checkRequirement(IntegrationServiceId.ZOOM)

  /**
   * When `satisfied` is true, the user has a live Zoom integration — there's nothing to warn about.
   * When `accountAllowed` is false, the enterprise config doesn't permit Zoom at all,
   * so the user has no way to connect it and showing a non-actionable warning would be pointless.
   */
  if (source !== 'zoom' || satisfied || !accountAllowed) {
    return null
  }

  return (
    <Row {...rowProps}>
      <Col {...colProps}>
        <ZoomOBFWarning />
      </Col>
    </Row>
  )
}
